import React, { useEffect, useState } from "react";

import Navigation from "../component/navigation";
import HeroSlider from "../component/heroSlider";
import Categories from "../component/categories";
import WeekDeal from "../component/weekDeal";
import OfferProduct from "../component/offerProduct";
import ControlledTabs from "../component/allProductsList";
import Brands from "../component/brands";
import SpecialOffer from "../component/specialOffer";
import Facilities from "../component/facilities";
import NewsLatter from "../component/newsLatter";
import Footer from "../component/footer";
import TopNavbar from "../component/topNavbar";
import { ScreenSizeProvider } from "../context/ScreenSizeContext";
// import { ProductProvider } from "../context/ProductContext";
import { useDispatch } from "react-redux";
import { fetchProducts } from "../redux/productSlice";
import TodaysDeals from "../component/todaysDeals";

const Homepage = () => {
  const dispatch = useDispatch();
   useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);
  return (
    <>
      <ScreenSizeProvider>
        <TopNavbar />
     
        <Navigation />
      </ScreenSizeProvider>
       <HeroSlider />
      
      {/* <ProductProvider>
      <OfferProduct /> 
       <WeekDeal />
       <ControlledTabs />
      
       
       
      </ProductProvider> */}
     
      <OfferProduct /> 
      <TodaysDeals/>
       <WeekDeal />
       <ControlledTabs />
      
       
      <Categories />
      <Brands />
      {/* <SpecialOffer /> */}
      <Facilities />
      <NewsLatter />
      <Footer />
    </>
  );
};
export default Homepage;
